export function systemNotificationOptions(description?: string) {
  return {
    body: description ?? "",
    icon: "/favicon-96x96-v3.png",
  }
}
